import { requestLaravel } from "../../../utils/api";
import { ApiResponse, EvaluationChartData, ExportFileResponse, ExportReportResponse, Ipagination, IPanopticEvaluationScoreCardList, IProjectEvaluationSummeryData, UserScore } from "./_models";

export interface PanopticProjectFiltersPayload {
  sector_id?: number;
  department_id?: number;
  location_id?: number;
  from_date?: string;
  to_date?: string;
  search?: string;
  score_range?: [number, number];
  page?: number;
  limit?: number;
  is_paginated?: number;
}



export function getPanopticEvaluationProjects(
  sectorId: number,
  departmentId: number,
  fromDate: string,
  toDate: string,
  search: string,
  scoreRange: [number, number],
  page?: number,
  perPage?: number,
  is_paginated?: boolean,
  signal?: AbortSignal
) {

  const data: PanopticProjectFiltersPayload = {
    sector_id: sectorId,
    department_id: departmentId,
    from_date: fromDate,
    to_date: toDate,
    search: search,
    score_range: scoreRange,
    page: page,
    limit: perPage,
    is_paginated: is_paginated ? 1 : 0
  };
  return requestLaravel<ApiResponse<{ projects: IPanopticEvaluationScoreCardList[], pagination: Ipagination }>>(
    "/projects/get-panoptic-evaluation-projects",
    data,
    { signal }
  );

}

export function getPanopticEvaluatorIndividualScores(projectId: number, signal?: AbortSignal) {
  return requestLaravel<ApiResponse<UserScore[]>>(
    "/projects/get-panoptic-evaluator-individual-scores",
    { project_id: projectId },
    { signal }
  );
}

export function getPanopticEvaluatorQuestionWeightedScores(projectId: number, signal?: AbortSignal) {
  return requestLaravel<ApiResponse<EvaluationChartData>>(
    "/projects/get-panoptic-evaluator-question-weighted-scores",
    { project_id: projectId },
    { signal },
  );

}

export function getPanopticEvaluationSummaryData(projectId: number, signal?: AbortSignal) {
  return requestLaravel<ApiResponse<IProjectEvaluationSummeryData>>(
    "/projects/get-panoptic-evaluation-summary-data",
    { project_id: projectId },
    { signal }
  );
}

export function exportPanopticEvaluationProjects(
  type: "excel" | "pdf"
) {

  return requestLaravel<ApiResponse<ExportFileResponse>>(
    "/projects/export-panoptic-evaluation-projects",
    {
      file_type: type
    }
  );
}

export function handleExportSummaryReportAPI(project_id: number): Promise<ApiResponse<ExportReportResponse>> {
  return requestLaravel<ApiResponse<ExportReportResponse>>("/project-reports/evaluation-summary", {
    project_id: project_id
  });
}